import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for Confluence whiteboard brainstorming.
 */
type ConfluenceWhiteboardBrainstormingData = {
	/**
	 * The chunk of brainstorming response.
	 */
	content: string;
	/**
	 * The content ID of the whiteboard.
	 */
	contentId: string;
};

/**
 * Properties for the Confluence whiteboard brainstorming command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceWhiteboardBrainstormingCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the whiteboard brainstorming request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the whiteboard brainstorming.
	 */
	data: ConfluenceWhiteboardBrainstormingData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
	/**
	 * The status of the whiteboard brainstorming.
	 */
	status: 'STREAMING' | 'SUCCESS';
}
/**
 * A command sent by a bridge API client to start a Confluence whiteboard brainstorming.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to start a Confluence whiteboard brainstorming.
 */
export const ConfluenceWhiteboardBrainstormingCommand =
	createCommand<ConfluenceWhiteboardBrainstormingCommandProperties>(
		'confluence-whiteboard-brainstorming-command',
	);
